import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Formik, Form, Field } from "formik";
import Cookies from "universal-cookie";

import { adminLogin } from "../../api/User";

import GetAdmin from "../../utils/getAdmin";
import Loading from "../loading";
import Notification from "../Notification";

const cookies = new Cookies();

const Login = () => {
  const [showErr, setShowErr] = useState(false);
  const [errContent, setErrContent] = useState("");
  const [adminData, setAdminData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState();
  const [showNotification, setShowNotification] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      const res = await GetAdmin();
      setAdminData(res);
      setLoading(false);
    };
    fetchData();
  }, []);

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const res = await adminLogin(values);
      if (res.status === 200) {
        console.log(res);
        if (!res.data.accessToken) {
          throw new Error("توکن دریافت نشد");
        }
        await cookies.set("jwt-auth", res.data.accessToken, {
          expires: undefined,
        });
        if (res.data.user.role === "manager") {
          navigate("/Dash");
        } else if (res.data.user.role === "questionMaker") {
          navigate("/Question");
        } else if (res.data.user.role === "postMaker") {
          navigate("/ArticlePage");
        }
      } else {
        setShowNotification(true);
        setStatus(res.status);
      }
    } catch (error) {
      setShowNotification(true);
      setStatus(502);
    } finally {
      setSubmitting(false);
    }
  };

  if (loading) {
    return <Loading />;
  }

  if (!adminData) {
    return null;
  }

  const getNotificationProps = () => {
    switch (status) {
      case 400:
        return {
          message: "نام کاربری یا رمز عبور اشتباه می باشد",
          type: "error",
        };

      case 500:
        return {
          message: "مشکل سرور لطفاً دقایقی دیگر امتحان کنید",
          type: "error",
        };
      case 502:
        return {
          message: "مشکل برنامه به سازنده برنامه اطلاع دهید",
          type: "error",
        };
      case 401:
        return {
          message: "نام کاربری یا رمز عبور اشتباه می باشد",
          type: "error",
        };
      case 404:
        return {
          message: "کاربری با این نام کاربری وجود ندارد",
          type: "info",
        };

      default:
        return null;
    }
  };

  const notificationProps = getNotificationProps();

  if (adminData === "empty") {
    return (
      <div className="flex items-center justify-center ">
        {showNotification ? (
          <Notification
            {...notificationProps}
            setShowNotification={setShowNotification}
            showNotification={showNotification}
          />
        ) : null}
        <div className="bg-white p-8 rounded-2xl shadow-xl w-full max-w-md mx-4">
          <div className="flex flex-col items-center mb-8">
            <img
              src={require("../../assets/maktabIcon.png")}
              alt="مکتب تحول"
              className="w-24 h-24 object-contain mb-4"
            />
            <h2 className="text-2xl font-bold text-[#075B4A]">
              ورود به پنل مدیریت
            </h2>
          </div>

          <Formik
            initialValues={{
              phone: "",
              password: "",
            }}
            onSubmit={handleSubmit}
          >
            {({ errors, touched, isSubmitting }) => (
              <Form>
                <div className="rounded-xl  my-5 flex flex-col gap-5 md:p-10">
                  <div>
                    <label
                      className="block text-sm font-medium text-gray-700 mb-2"
                      htmlFor="phone"
                    >
                      شماره موبایل
                    </label>
                    <Field
                      id="phone"
                      name="phone"
                      type="tel"
                      dir="ltr"
                      className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#075B4A] focus:border-transparent transition duration-200"
                      placeholder="09xxxxxxxxx"
                    />
                    {errors.phone && touched.phone && (
                      <div className="text-red-500 text-sm mt-1">
                        {errors.phone}
                      </div>
                    )}
                  </div>

                  <div>
                    <label
                      className="block text-sm font-medium text-gray-700 mb-2"
                      htmlFor="password"
                    >
                      رمز عبور
                    </label>
                    <Field
                      id="password"
                      name="password"
                      type="password"
                      className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#075B4A] focus:border-transparent transition duration-200"
                      placeholder="رمز عبور خود را وارد کنید"
                    />
                    {errors.password && touched.password && (
                      <div className="text-red-500 text-sm mt-1">
                        {errors.password}
                      </div>
                    )}
                  </div>

                  {showErr && (
                    <div className="text-red-500 text-sm text-center">
                      {errContent}
                    </div>
                  )}

                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="w-full bg-[#075B4A] text-white py-3 rounded-lg hover:bg-[#064a3c] transition duration-200 font-medium disabled:opacity-50"
                  >
                    {isSubmitting ? "در حال ورود..." : "ورود به حساب کاربری"}
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    );
  } else if (adminData.role === "postMaker") {
    navigate("/ArticlePage");
  } else if (adminData.role === "questionMaker") {
    navigate("/Question");
  } else {
    navigate("/Dash");
  }
};

export default Login;
